document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
        if (event.target.matches('.change-color-product-coll')) {
          // console.log(clickedElement)
          const clickedElement = event.target;
           var main_product_id =  clickedElement.getAttribute('data-main-product-id');
            var color_product_id = clickedElement.getAttribute('data-product-color-id');     
          requestAnimationFrame(() => {
            
          
            // console.log(1,main_product_id);
            document.getElementById(`${color_product_id}`).style.display = 'block';
            // console.log(2,main_product_id);
            var pProductFamilyAllClasses = document.querySelectorAll(`.${main_product_id}`);
            pProductFamilyAllClasses.forEach(function(element) {
                  
                  if(!element.classList.contains(`${color_product_id}`)){
                    element.style.display = 'none';
                  }else{
                    element.style.display = 'block';
                  }
              });
          });
           const img_to_show_video_alternative = `video-alternative-sec-img-show-${main_product_id}`;
            var img_to_show_video_alternative_var = document.querySelectorAll(`.${img_to_show_video_alternative}`);
            img_to_show_video_alternative_var.forEach(function(element) {
              element.classList.add("product-card__image--primary");
              element.classList.remove("product-card__image--secondary");
            });
          const mainProductHandle = clickedElement.getAttribute('data-main-product-handle');
          var main_product = document.querySelector(`product-card[handle="${mainProductHandle}"]`);

            const productCardHandle = document.querySelector(`product-card[handle="${mainProductHandle}"]`);
            const productUrl = clickedElement.getAttribute('data-product-url');
            const productTitle = clickedElement.getAttribute('data-product-title');
            const productInfo = productCardHandle.querySelector('.product-card__info');
            const productTitleElement = productInfo.querySelector('.product-title');
            const productPrice = productCardHandle.querySelector('div[class="v-stack justify-items-center gap-1"]');
            productTitleElement.href = productUrl;
            productTitleElement.innerHTML = productTitle;
            document.querySelectorAll(`button[data-main-product-handle="${mainProductHandle}"]`).forEach(otf => {
                otf.classList.remove("is-selected");
            });
            clickedElement.classList.add("is-selected");
        }
    });
});

